<template>
  <v-app>
 
    <v-app-bar app>
      <v-toolbar-title class="headline text-uppercase">
        <span>المنصة الرقمية لشركة تطوير للنقل </span>
         
        <span class="font-weight-light">(رافد)</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <!-- <v-btn text href="#">
        <span class="mr-2" style="letter-spacing:0;">تطوير النقل التعليمي</span>
      </v-btn>-->

      <v-btn v-if="isUser&&istokenValid" text @click="showApps">
        <span class="mr-2" style="letter-spacing:0;">قائمة أنظمة النقل</span>
      </v-btn>
        <template>
          <div class="text-center"> 
            <v-dialog
              v-model="dialog"
              hide-overlay
              persistent
              width="300">
            <v-card color="primary" dark>
              <v-card-text>
                سيتم تسجيل خروجك فى خلال 30 ثانية إذا لم يتم عمل أى إجراء 
                <v-progress-linear
                  indeterminate
                  color="white"
                  class="mb-0">
                 </v-progress-linear>
              </v-card-text>
            </v-card>
          </v-dialog>
        </div>
      </template>
      <v-menu left bottom>
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on">
            <v-icon>mdi-dots-vertical</v-icon>
          </v-btn>
        </template>


        <v-list>
          <v-list-item v-for="{id, title, action} in menu" :key="id" @click="() => {action()}">
            <v-list-item-title>{{title}}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>

    <v-content class="bg" :style="{ backgroundImage: 'url(\'' + image + '\')' }">
      <Apps v-if="isUser&&istokenValid" />
      <Login v-if="!isUser||!istokenValid" /> 
    </v-content>
  </v-app>
</template>

<script>
// import HelloWorld from "./components/HelloWorld";
import Login from "./components/Login";
import Apps from "./components/Apps"; 
import bg from "./assets/svg/bg.png";


import alasql from "alasql";
import _ from "lodash"; 



export default {
  name: "App",
  components: {
    Login,
    Apps 
  }, 
  onIdle() {  
    if(this.$store.state.token != null)
    { 
      this.dialog= true;   
      setTimeout(() => (this.timeOut()), 30000); 
      this.timeoutFlag=1;
    }
  },
  onActive() {  
    if(this.$store.state.token != null)
    {  
      this.timeoutFlag=0; 
      this.timeOut(); 
    }
  },
  data() {
    return {
      dialog: false, 
      timeoutFlag:0,
      image: bg,
      menu: [
        {
          id: 1,
          title: "تسجيل الخروج",
          action: () => {
            console.log("logout");
            this.logout();
          }
        }
      ]
    };
  },

  mounted() {
    window.alasql = alasql; 
  },

  methods: {
 
    logout() {
      this.$store.dispatch("logoutAction", {});
    },
    timeOut() { 
      this.dialog= false; 
      if(this.timeoutFlag==1)
      {
        this.logout();   
      }
    },
    showApps() {
      this.$store.dispatch("setActiveAppAction", null);
    }
  },

  computed: { 
    userProfile() {
      return this.$store.state.userProfile;
    },

    userPrivilege() {
      return this.$store.state.userPrivilege;
    },
    token() {
      return this.$store.state.token;
    },

    isUser() { 
      return this.$store.state.token != null;
    },
    istokenValid(){

        var base64Url = this.$store.state.token.split('.')[1];
        var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        var jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      }).join('')); 
      var expirationDate=JSON.parse(jsonPayload).exp;
      if(expirationDate > Date.now() / 1000)
      {
        //setTimeout(this.timeOut, 3000);

        return true;
      }
    
    return false;
    }
  }
};
</script>
<style scoped>
.bg {
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  background-repeat: no-repeat;
  background-position-y: bottom;
  background-color:#162e4d;
  background-size:100vh;
}



</style>

